var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_222_760",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 14,
    height: 14,
    fill: "#008254"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_222_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.41667 12.25C3.09583 12.25 2.82118 12.1358 2.59271 11.9073C2.36424 11.6788 2.25 11.4042 2.25 11.0833V2.91667C2.25 2.59583 2.36424 2.32118 2.59271 2.09271C2.82118 1.86424 3.09583 1.75 3.41667 1.75H7.5V2.91667H3.41667V11.0833H11.5833V7H12.75V11.0833C12.75 11.4042 12.6358 11.6788 12.4073 11.9073C12.1788 12.1358 11.9042 12.25 11.5833 12.25H3.41667ZM6.15833 9.15833L5.34167 8.34167L10.7667 2.91667H8.66667V1.75H12.75V5.83333H11.5833V3.73333L6.15833 9.15833Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/btn-icon.8e30b3d185588452ed9aa9a2475c63b7.svg";